import React from 'react';

// Shared bits for the licensing route. The repo has no generic Button/Card
// primitives, so these are local to /licensing rather than a new global system.

export const Eyebrow = ({ children }) => (
  <p className="m-0 font-mono text-xs font-medium uppercase tracking-[0.16em] text-cyan-400">
    {children}
  </p>
);

export const Lede = ({ children, className = '' }) => (
  <p className={`m-0 max-w-[62ch] text-lg text-gray-400 ${className}`}>{children}</p>
);

export const SectionHead = ({ eyebrow, title, lede }) => (
  <div className="mb-11 grid max-w-[70ch] gap-3.5">
    {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
    <h2 className="m-0 text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl">
      {title}
    </h2>
    {lede && <Lede>{lede}</Lede>}
  </div>
);

export const Section = ({ id, children, className = '' }) => (
  <section id={id} className={`border-t border-gray-800 py-16 sm:py-24 ${className}`}>
    <div className="mx-auto w-full max-w-6xl px-6">{children}</div>
  </section>
);

export const Card = ({ tag, title, children, className = '' }) => (
  <div
    className={`grid content-start gap-2.5 rounded-xl border border-gray-700/60 bg-gray-800/40 p-6 ${className}`}
  >
    {tag && (
      <span className="font-mono text-[0.7rem] uppercase tracking-[0.14em] text-cyan-400">
        {tag}
      </span>
    )}
    {title && <h3 className="m-0 text-base font-semibold text-white">{title}</h3>}
    {children}
  </div>
);

export const CardText = ({ children }) => (
  <p className="m-0 text-[0.95rem] text-gray-400">{children}</p>
);

export const CardList = ({ items }) => (
  <ul className="mt-1 mb-0 list-disc pl-[18px] text-[0.92rem] text-gray-400">
    {items.map((item) => (
      <li key={item} className="my-1">
        {item}
      </li>
    ))}
  </ul>
);

const BASE_BTN =
  'inline-flex items-center gap-2 rounded-[10px] px-5 py-3 text-[0.95rem] font-semibold no-underline transition-all duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-400/60 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900';

export const PrimaryLink = ({ href, children, className = '' }) => (
  <a href={href} className={`${BASE_BTN} bg-cyan-400 text-gray-900 hover:bg-cyan-300 ${className}`}>
    {children}
  </a>
);

export const GhostLink = ({ href, children, className = '' }) => (
  <a
    href={href}
    className={`${BASE_BTN} border border-gray-600 text-white hover:border-cyan-400 hover:text-cyan-300 ${className}`}
  >
    {children}
  </a>
);
